import React from 'react';
import { Search, Download, ChevronLeft, ChevronRight } from 'lucide-react';
import { Input } from './ui/input';
import { Button } from './ui/button';

/**
 * Barre de recherche, filtre par statut et export, partagée par les listes
 * de devis et de messages.
 */
export const ListToolbar = ({
  recherche,
  onRecherche,
  statut,
  onStatut,
  statuts,
  onExport,
  total,
  libelleTotal,
}) => (
  <div className="flex flex-wrap items-center gap-3">
    <div className="relative flex-1 min-w-[220px]">
      <Search
        className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400"
        aria-hidden="true"
      />
      <Input
        type="search"
        value={recherche}
        onChange={(e) => onRecherche(e.target.value)}
        placeholder="Rechercher un nom, un email, un téléphone…"
        className="pl-9 h-11"
        aria-label="Rechercher"
      />
    </div>

    <select
      value={statut}
      onChange={(e) => onStatut(e.target.value)}
      aria-label="Filtrer par statut"
      className="h-11 rounded-md border border-gray-200 bg-white px-3 text-sm focus:border-blue-600 focus:outline-none"
    >
      <option value="">Tous les statuts</option>
      {statuts.map(({ valeur, libelle }) => (
        <option key={valeur} value={valeur}>
          {libelle}
        </option>
      ))}
    </select>

    <Button variant="outline" onClick={onExport} className="gap-2 h-11">
      <Download className="w-4 h-4" aria-hidden="true" />
      Exporter
    </Button>

    <span className="text-sm text-gray-500 ml-auto">
      {total} {libelleTotal}
      {total > 1 ? 's' : ''}
    </span>
  </div>
);

export const Pagination = ({ skip, limit, total, onChange }) => {
  const pageActuelle = Math.floor(skip / limit) + 1;
  const pages = Math.max(1, Math.ceil(total / limit));
  if (pages <= 1) return null;

  return (
    <nav
      aria-label="Pagination"
      className="flex items-center justify-center gap-2 pt-4"
    >
      <Button
        variant="outline"
        size="sm"
        disabled={skip === 0}
        onClick={() => onChange(Math.max(0, skip - limit))}
        className="gap-1"
      >
        <ChevronLeft className="w-4 h-4" aria-hidden="true" />
        Précédent
      </Button>

      <span className="text-sm text-gray-600 px-3">
        Page {pageActuelle} sur {pages}
      </span>

      <Button
        variant="outline"
        size="sm"
        disabled={skip + limit >= total}
        onClick={() => onChange(skip + limit)}
        className="gap-1"
      >
        Suivant
        <ChevronRight className="w-4 h-4" aria-hidden="true" />
      </Button>
    </nav>
  );
};

export default ListToolbar;
